import { render, staticRenderFns } from "./addToPriceListDialog.vue?vue&type=template&id=1dfb82b4"
import script from "./addToPriceListDialog.vue?vue&type=script&lang=js"
export * from "./addToPriceListDialog.vue?vue&type=script&lang=js"
import style0 from "./addToPriceListDialog.vue?vue&type=style&index=0&id=1dfb82b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports